module.exports = __webpack_public_path__ + "img/business.e7db86a5.png";